import React, { useEffect, useMemo, useRef, useState } from "react";
import { ChevronDown, Search } from "lucide-react";

export default function TeamDropdown({
  teams = [],
  value,
  onChange,
  placeholder = "All Teams",
  loading = false,
  className = "",
  dropdownHeight = "max-h-60",
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredTeams = useMemo(() => {
    return (teams || []).filter((team) =>
      (team.team_name || team.teamName || "")
        .toLowerCase()
        .includes(search.toLowerCase()),
    );
  }, [teams, search]);

  const selectedLabel =
    value === ""
      ? placeholder
      : teams.find((t) => String(t.id) === String(value))?.team_name ||
        teams.find((t) => String(t.id) === String(value))?.teamName ||
        placeholder;

  return (
    <div ref={dropdownRef} className={`relative w-full ${className}`}>
      <button
        type="button"
        disabled={loading}
        onClick={() => setOpen((o) => !o)}
        className="w-full h-10 border rounded-lg bg-white px-3 text-sm flex justify-between items-center"
      >
        <span className="truncate text-gray-600">
          {loading ? "Loading..." : selectedLabel}
        </span>

        <ChevronDown size={16} />
      </button>

      {open && (
        <div className="absolute left-0 top-full mt-1 w-full bg-white border rounded-lg shadow-lg z-50">
          <div className="p-2 border-b flex items-center gap-2">
            <input
              autoFocus
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search..."
              className="w-[120px] outline-none text-sm"
            />
          </div>

          <div className={`${dropdownHeight} overflow-y-auto`}>
            <button
              className="w-full text-left px-3 py-2 hover:bg-gray-100 text-sm"
              onClick={() => {
                onChange("");
                setOpen(false);
                setSearch("");
              }}
            >
              {placeholder}
            </button>

            {filteredTeams.map((team) => (
              <button
                key={team.id}
                className="w-full text-left px-3 py-2 hover:bg-gray-100 text-sm"
                onClick={() => {
                  onChange(String(team.id));
                  setOpen(false);
                  setSearch("");
                }}
              >
                {team.team_name || team.teamName}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
